/**
 * Mini workloads
 */
enum MiniWorkLoad {
    Mail,
    Calendar,
    People,
}

export default MiniWorkLoad;
